export const transformColumnSortToQuery = (sort) => {
  const sortArray = [sort].flat()

  return sortArray.map(({ id, desc }) => ({
    field: id,
    order: desc ? 'desc' : 'asc'
  }))
}
